import ApiService from './ApiService'

class ClientService {
  static async getClients (query) {
    return await ApiService.GET('/api/clients/index.json', query)
  }

  static async getClient (id) {
    return await ApiService.GET(`/api/clients/view/${id}.json`)
  }

  static async saveClient (id, data) {
    return await ApiService.POST(`/api/clients/edit/${id}.json`, data)
  }

  static async createClient (data) {
    return await ApiService.POST('/api/clients/create.json', data)
  }

  static async sendLoginEmail (id) {
    return await ApiService.GET(`/api/clients/send-login-email/${id}`)
  }

  static async getClientInspectionAddress (id) {
    return await ApiService.GET(`/api/clients/edit-inspections-addresses/${id}.json`)
  }

  static async editClientInspectionAddress (id, data) {
    return await ApiService.POST(`/api/clients/edit-inspections-addresses/${id}.json`, data)
  }

  static async createClientInspectionAddress (id, data) {
    return await ApiService.POST(`/api/clients/add-inspections-addresses/${id}.json`, data)
  }

  static async getInspectionsAddressesEquipmentDependencies (clientsAddressId) {
    return await ApiService.GET(`/api/clients/add-inspections-addresses-equipment/${clientsAddressId}.json`)
  }

  static async createInspectionsAddressesEquipment (clientsAddressId, data) {
    return await ApiService.POST(`/api/clients/add-inspections-addresses-equipment/${clientsAddressId}.json`, data)
  }

  static async editInspectionsAddressesEquipment (clientsAddressesEquipmentId, data) {
    return await ApiService.POST(`/api/clients/edit-inspections-addresses-equipment/${clientsAddressesEquipmentId}.json`, data)
  }

  static async getInspectionsAddressesEquipment (clientsAddressesEquipmentId) {
    return await ApiService.GET(`/api/clients/edit-inspections-addresses-equipment/${clientsAddressesEquipmentId}.json`)
  }

  static async getSynceds (query) {
    return await ApiService.GET('/api/clients/synced.json', query)
  }

  static async getSynced (clientId) {
    return await ApiService.GET(`/api/clients/synced/${clientId}.json`)
  }

  static async importSynced (clientId) {
    return await ApiService.POST(`/api/clients/synced/${clientId}.json`)
  }
}

export default ClientService
